import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL, post } from "../api";

export type RequestResumeOtpVariables = {
  email: string;
};

function useRequestResumeOtp(
  options?: MutationOptions<
    APIResponse<any>,
    APIError,
    RequestResumeOtpVariables
  >
) {
  const {
    isLoading: requesting,
    isError: isRequestError,
    error: requestError,
    mutate: requestResumeOtp,
    reset,
  } = useMutation<APIResponse<any>, APIError, RequestResumeOtpVariables>(
    "request_resume_profile_otp",
    async (variables) =>
      await post(
        API_URL + "/onboarding/users/onboarding/resume-profile/request-email",
        variables
      ),
    {
      ...options,
    }
  );

  return {
    requestResumeOtp,
    requesting,
    isRequestError,
    requestError,
    resetRequest: reset,
  };
}

export default useRequestResumeOtp;
